import {Middleware} from "@reduxjs/toolkit";

const flightsMiddleware: Middleware = store => next => action => {

    return next(action);
}
export default flightsMiddleware;
